import React, { useRef, useEffect, useCallback, ComponentPropsWithoutRef } from 'react';
import { trackEvent as trackAnalyticsEvent } from 'app/lib/analytics';

interface MetricProps extends ComponentPropsWithoutRef<'div'> {
  name: string;
  on?: string;
  data?: any;
  options?: any;
}

export const Metric: React.FC<MetricProps> = ({ on = 'click', name, data, options, children, style, ...props }) => {
  const node = useRef<HTMLDivElement>(null);

  const trackEvent = useCallback(() => {
    trackAnalyticsEvent(name, data, options);
  }, [name, data, options]);

  useEffect(() => {
    if (node.current) node.current.addEventListener(on, trackEvent);

    return () => {
      if (node.current) node.current.removeEventListener(on, trackEvent);
    };
  }, []);

  return (
    <div {...props} data-testid="rs-metric" style={{ display: 'contents', ...style }} ref={node}>
      {children}
    </div>
  );
};
